import type { ChartAxisLabelMode } from './types';

export type AxisLabelLayout = {
  angle: number;
  textAnchor: 'start' | 'middle' | 'end';
  height: number;
  bottomMargin: number;
  stacked: boolean;
};

export function chartAxisLabelLayout(
  mode: ChartAxisLabelMode | undefined,
  autoRotate: boolean,
): AxisLabelLayout {
  const effective = mode && mode !== 'auto'
    ? mode
    : autoRotate
      ? 'rotate-45'
      : 'horizontal';
  if (effective === 'rotate-45') {
    return { angle: -45, textAnchor: 'end', height: 70, bottomMargin: 48, stacked: false };
  }
  if (effective === 'rotate-90') {
    return { angle: -90, textAnchor: 'end', height: 100, bottomMargin: 72, stacked: false };
  }
  if (effective === 'stacked') {
    return { angle: 0, textAnchor: 'middle', height: 66, bottomMargin: 48, stacked: true };
  }
  return { angle: 0, textAnchor: 'middle', height: 32, bottomMargin: 8, stacked: false };
}

export function stackAxisLabel(value: unknown, maxChars = 12, maxLines = 3): string[] {
  const text = String(value ?? '');
  const tokens = text.split(/[\s_-]+/).filter(Boolean);
  const parts = tokens.length > 1
    ? tokens
    : text.match(new RegExp(`.{1,${maxChars}}`, 'g')) ?? [''];
  const lines: string[] = [];

  for (const part of parts) {
    const current = lines[lines.length - 1];
    if (current && `${current} ${part}`.length <= maxChars) {
      lines[lines.length - 1] = `${current} ${part}`;
    } else {
      lines.push(part);
    }
  }
  if (lines.length > maxLines) {
    const visible = lines.slice(0, maxLines);
    visible[maxLines - 1] = `${visible[maxLines - 1].slice(0, Math.max(1, maxChars - 1))}…`;
    return visible;
  }
  return lines;
}
